export function hex2RgbColor(hexColor: string, opacity?: string | number) {
  let normalHex = hexColor.replace('#', '');
  if (normalHex.length === 3) {
    normalHex = `${normalHex[0]}${normalHex[0]}${normalHex[1]}${normalHex[1]}${normalHex[2]}${normalHex[2]}`;
  }
  if (normalHex.length !== 6) {
    console.error(new Error(`Color: ${hexColor} is invalid value`));
    return '';
  }
  const rgbaString = `${Number('0x' + normalHex[0] + normalHex[1])},${Number(
    '0x' + normalHex[2] + normalHex[3]
  )},${Number('0x' + normalHex[4] + normalHex[5])}`;
  if (opacity !== undefined) {
    return `rgba(${rgbaString},${opacity})`;
  }
  return `rgb(${rgbaString})`;
}

// 16进制颜色转 rgba 颜色
export const colorRgb = (colorHex: string, alpha = 1) => {
  const reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
  let color = colorHex.toLowerCase();
  if (reg.test(color)) {
    // 如果只有三位的值，需变成六位，如：#fff => #ffffff
    if (color.length === 4) {
      let colorNew = '#';
      for (let i = 1; i < 4; i += 1) {
        colorNew += color.slice(i, i + 1).concat(color.slice(i, i + 1));
      }
      color = colorNew;
    }
    // 处理六位的颜色值，转为RGB
    const colorChange = [];
    for (let i = 1; i < 7; i += 2) {
      colorChange.push(parseInt('0x' + color.slice(i, i + 2)));
    }
    return `RGB(${colorChange.join(',')}, ${alpha})`;
  } else {
    return color;
  }
};
